import React from 'react';
import BackupManagement from '../../components/SuperAdmin/BackupManagement';

const BackupManagementPage: React.FC = () => {
  return <BackupManagement />;
};

export default BackupManagementPage;
